import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { trackWhatsAppClick, trackInstagramClick } from "@/lib/analytics";
import { usePagesContent } from "@/data/pages";

const WA_NUMBER = "393450416676";
const WA_MESSAGE = encodeURIComponent(
  "Ciao Alessandro! Ti scrivo dal sito Mantel Summer Heels Experience."
);

export const WhatsAppFloating = () => {
  const { footer } = usePagesContent();

  return (
    <div className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[90] flex flex-col items-end gap-3">
      {/* Instagram bubble (above WhatsApp) */}
      <motion.a
        href={footer.instagram_url || "https://www.instagram.com/mantelheelsexperience/"}
        target="_blank"
        rel="noreferrer"
        data-testid="instagram-floating"
        aria-label="Apri profilo Instagram"
        onClick={() => trackInstagramClick("floating_button")}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.7, type: "spring", stiffness: 200, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="relative w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center shadow-[0_14px_30px_-8px_rgba(228,64,95,0.55)] transition-colors group text-white"
        style={{
          background:
            "radial-gradient(circle at 30% 110%, #FDC468 0%, #FA7E1E 20%, #D62976 45%, #962FBF 65%, #4F5BD5 100%)",
        }}
      >
        <Instagram size={22} className="relative" strokeWidth={1.8} />

        {/* Hover label */}
        <span className="hidden sm:block absolute right-full mr-3 bg-[#2A1810] text-[#FBF6EA] text-xs font-medium tracking-wider uppercase px-3 py-2 rounded-full whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Seguimi su Instagram
        </span>
      </motion.a>

      {/* WhatsApp bubble */}
      <motion.a
        href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-floating"
        aria-label="Scrivi su WhatsApp"
        onClick={() => trackWhatsAppClick("floating_button")}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.5, type: "spring", stiffness: 200, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#1FB855] flex items-center justify-center shadow-[0_14px_30px_-8px_rgba(37,211,102,0.55)] transition-colors group"
      >
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          className="relative w-7 h-7 sm:w-8 sm:h-8 text-white"
          aria-hidden="true"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
        </svg>

        <span className="hidden sm:block absolute right-full mr-3 bg-[#2A1810] text-[#FBF6EA] text-xs font-medium tracking-wider uppercase px-3 py-2 rounded-full whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Scrivimi su WhatsApp
        </span>
      </motion.a>
    </div>
  );
};
